<template>
  <div class="management-agent-box">
    <div class="content-box">
      <!-- 搜索栏 -->
      <div class="content_title data_screen">
        <div class="data_screen_line">
          <span class="title" slot="reference" @click="clickCancel"
            >学院管理 > 轮播图管理</span
          >

          <span class="btn search_btn">
            <el-input
              v-model="search.content"
              placeholder="课程分类/名称"
              style="width: 300px"
              size="small"
              suffix-icon="el-icon-search"
              @change="pageChange(1)"
              clearable
            />
          </span>
          <span class="data_screen_tab">
            <!-- 分类  -->
            <el-select
              v-model="search.disabledStatus"
              clearable
              placeholder="请选择"
              size="small"
              style="width: 150px"
              @change="pageChange(1)"
            >
              <el-option label="全部" value />
              <el-option label="启用" value="1" />
              <el-option label="禁用" value="0" />
            </el-select>
          </span>
          <el-button
            class="btn search_btn"
            size="small"
            @click="pageChange(1)"
            >查询</el-button>
        </div>
        <el-button
          type="primary"
          class="btn_add btn"
          size="small"
          @click="clickAdd"
          >添加轮播图</el-button
        >
      </div>
      <!-- 具体内容 -->
      <div class="content">
        <div class="content_auto">
          <!-- 表格 -->
          <el-table :data="table_data" style="width: 100%">
            <el-table-column
              prop="sortNo"
              label="轮播排序"
              align="center"
            ></el-table-column>
            <el-table-column prop="coverImage" label="封面图片" align="center">
              <template slot-scope="scope">
                <el-image class="tableImage" :src="scope.row.coverImageTemp">
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              prop="groupName"
              label="所属分类"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="name"
              label="课程名称"
              align="center"
            ></el-table-column>
            <el-table-column prop="type" label="课程类型" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 1">公众号文章</span>
                <span v-if="scope.row.type == 2">视频教程</span>
              </template>
            </el-table-column>
            
            <el-table-column prop="disabledStatus" label="状态" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.disabledStatus == 1">启用</span>
                <span v-if="scope.row.disabledStatus != 1" style="color: red"
                  >禁用</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="updateTime"
              label="更新时间"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  v-if="scope.row.disabledStatus != 1"
                  style="color: #00cb9f"
                  @click="clickStatus(scope.row)"
                  >启用</el-button
                >
                <el-button
                  type="text"
                  v-if="scope.row.disabledStatus == 1"
                  style="color: red"
                  @click="clickStatus(scope.row)"
                  >禁用</el-button
                >&nbsp;
                <el-button
                  type="text"
                  style="color: #00cb9f"
                  @click="clickUpdate(scope.row)"
                  >编辑</el-button
                >&nbsp;
                <el-button
                  type="text"
                  style="color: red"
                  @click="clickDelete(scope.row)"
                  >删除</el-button
                >&nbsp;
                <el-button
                  type="text"
                  style="color: #00cb9f"
                  @click="clickInfo(scope.row)"
                  >详情</el-button
                >&nbsp;
              </template>
            </el-table-column>
          </el-table>
          <!-- 表格结束 -->
          <!-- 分页 -->
          <div class="page">
            <el-pagination
              background
              layout="total,prev, pager, next"
              :total="page.total"
              :page-size="page.size"
              @current-change="pageChange"
            ></el-pagination>
          </div>
        </div>
      </div>

      <!-- 添加成员弹出框 -->
      <el-dialog
        :title="dialogType == 1 ? '添加轮播图' : '编辑轮播图'"
        :rules="rules"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="520px"
      >
        <div class="dialog_context">
          <el-form :model="form" :rules="rules" ref="addForm">
            <el-form-item
              label="所属课程"
              :label-width="dialogWidth"
              prop="tutorialId"
            >
              <el-cascader
                expand-trigger="hover"
                :options="selectChangeData"
                v-model="form.tutorialId"
                style="width: 100%"
                :disabled="dialogType != 1"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item
              label="排序编号"
              :label-width="dialogWidth"
              prop="sortNo"
            >
              <el-input-number
                v-model="form.sortNo"
                :min="1"
                :precision="0"
                label="排序编号"
              ></el-input-number>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="addSubmit('addForm')"
            class="btn"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 课程详情 -->
      <el-dialog
        title="课程详情"
        :rules="rules"
        :visible.sync="dialogVisibleByInfo"
        :close-on-click-modal="false"
        width="560px"
      >
        <div class="dialog_context">
          <el-form :model="infoData" :rules="rules">
            <el-form-item
              label="轮播排序"
              :label-width="dialogWidth"
            >
              <el-input
                v-model="infoData.sortNo"
                autocomplete="off"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item
              label="所属课程"
              :label-width="dialogWidth"
              prop="name"
            >
              <el-input
                v-model="infoData.nameTemp"
                autocomplete="off"
                disabled
              ></el-input>
            </el-form-item>
            
            <el-form-item
              label="课程封面"
              :label-width="dialogWidth"
              prop="name"
            >
              <el-upload
                class="avatar-uploader"
                :action="baseURL + '/api/common/file/upload/image'"
                :show-file-list="false"
                accept=".jpg,.jpeg,.png,.gif"
                disabled
              >
                <img
                  v-if="infoData.coverImageTemp"
                  :src="infoData.coverImageTemp"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            
            <el-form-item
              label="课程类型"
              :label-width="dialogWidth"
            >
              <el-select
                v-model="infoData.type"
                placeholder="请选择"
                style="width: 100%"
                disabled
              >
                <el-option label="公众号文章" value="1"></el-option>
                <el-option label="视频教程" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="infoData.type == 1"
              label="文章连接"
              :label-width="dialogWidth"
            >
              <el-input
                v-model="infoData.officialAccountLink"
                autocomplete="off"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="infoData.type == 2"
              label="视频教程"
              :label-width="dialogWidth"
            >
              <el-upload
                class="avatar-uploader"
                :action="baseURL + '/api/common/file/upload/file'"
                :show-file-list="false"
                accept=".mp4,.avi,.wmv,.3gp"
                disabled
              >
                <video
                  controls
                  v-if="infoData.videoLinkTemp"
                  :src="infoData.videoLinkTemp"
                  class="avatar"
                  muted
                  autoplay
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item
              v-if="infoData.type == 2"
              label="文字内容"
              :label-width="dialogWidth"
            >
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入内容"
                disabled
                v-model="infoData.textContent"
                max="200"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisibleByInfo = false"
            >关 闭</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      // 搜索
      // 弹出框显示
      dialogVisible: false,
      dialogWidth: "100px",
      // 弹出窗类型：1 添加
      dialogType: 1,
      // 添加成员的数据
      form: {
        id: null,
        tutorialId: null,
        sortNo: null,
        disabledStatus: null,
      },
      // 课程详情
      dialogVisibleByInfo: false,
      infoData: {
        id: null,
        categoriesId: null,
        name: null,
        nameTemp: null,
        type: null,
        sortNo: null,
        coverImage: null,
        coverImageTemp: null,
        officialAccountLink: null,
        videoLink: null,
        videoLinkTemp: null,
        textContent: null,
        disabledStatus: null,
      },
      // 下拉框选择
      selectChangeData: [],
      // 校验规则
      rules: {
        tutorialId: [
          { required: true, message: "请选择课程", trigger: "blur" },
        ],
        sortNo: [
          { required: true, message: "请输入排序编号", trigger: "blur" },
        ],
      },
      search: {
        content: null,
        disabledStatus: "",
      },
      // 分页属性
      page: {
        currPage: 1,
        size: 10,
        total: 100,
      },
      // 表格数据
      table_data: [],
      // return 结束
    };
  },
  updated() {},
  created() {
    this.baseURL = this.$axios.defaults.baseURL;
    this.query();
    var that = this;
    // 逻辑处理
    that.$axios
      .post("/api/web/tutorial/categories/queryTutorialCategoriesTree", null)
      .then((res) => {
        if (res.data.code == 1000) {
          that.selectChangeData = res.data.data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    // 点击了取消
    clickCancel() {
      sessionStorage.setItem("dataInfo", null);
      this.$router.push({ path: "/tutorial" });
    },
    // 分页改变
    pageChange(res) {
      this.page.currPage = res;
      this.query();
    },
    // 点击了详情
    clickInfo(row) {
      this.infoData = row;
      this.infoData.coverImageTemp = row.coverImage
        ? this.baseURL + row.coverImage
        : null;
      this.infoData.videoLinkTemp = row.videoLink
        ? this.baseURL + row.videoLink
        : null;
      this.infoData.nameTemp = row.groupName+" / "+row.name;
      // 显示
      this.dialogVisibleByInfo = true;
    },
    // 点击了状态
    clickStatus(row) {
      var that = this;
      this.$confirm(
        (row.disabledStatus == 1 ? "禁用" : "启用") +
          "【" +
          row.name +
          "】课程分类, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        var data = {
          id: row.id,
          name: row.name,
          disabledStatus: row.disabledStatus == 1 ? 0 : 1,
        };
        // 逻辑处理
        that.postJson("/api/web/carousel/updateDisableStatus", data);
      });
    },
    // 点击删除
    clickDelete(row) {
      var that = this;
      this.$confirm("删除【" + row.name + "】课程分类, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var data = {
          id: row.id,
        };
        // 逻辑处理
        that.postJson("/api/web/carousel/deleteCarousel", data);
      });
    },
    // 点击了添加
    clickAdd() {
      this.dialogType = 1;
      // 初始化添加成员数据
      this.form = {
        id: null,
        tutorialId: null,
        sortNo: null,
        disabledStatus: null,
      };
      // 显示
      this.dialogVisible = true;
    },
    // 点击了编辑
    clickUpdate(row) {
      this.dialogType = 2;
      // 初始化添加成员数据
      this.form = {
        id: row.id,
        tutorialId: row.tutorialId,
        disabledStatus: row.disabledStatus,
        sortNo: row.sortNo,
      };
      // 显示
      this.dialogVisible = true;
    },
    // 提交
    addSubmit(ref) {
      var that = this;
      // 表单校验
      this.$refs[ref].validate((valid) => {
        // 校验结果
        if (!valid) {
          // 校验不通过
          return;
        }

        var url = "/api/web/carousel/updateCarousel";
        if (that.dialogType == 1) {
          url = "/api/web/carousel/addCarousel";
          that.form.id = null;
        }
        // 逻辑处理
        that.postJson(url, {
          id: that.form.id,
          tutorialId: that.form.tutorialId[1],
          sortNo: that.form.sortNo,
        });
      });
    },
    postJson(url, data) {
      var that = this;
      // 逻辑处理
      that.$axios
        .post(url, data)
        .then((res) => {
          if (res.data.code == 1000) {
            that.$message.success("操作成功");
            that.page.currPage = 1;
            that.dialogVisible = false;
            that.query();
          } else if (res.data.code == 4030) {
            that.table_data = [];
          } else if (res.data.code == 2001) {
            that.$message.error("登录失效，请重新登录");
            that.$router.push({ path: "/login" });
          } else {
            that.$message.info(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询数据
    query() {
      let that = this;
      const url = "/api/web/carousel/pageQuery";
      that.table_data = [];
      this.$axios
        .post(url, {
          page: this.page.currPage,
          size: this.page.size,
          param: {
            name: this.search.content,
            disabledStatus: this.search.disabledStatus,
          },
        })
        .then((res) => {
          if (res.data.code == 1000) {
            res.data.data.list.forEach((item) => {
              item.coverImageTemp = that.baseURL + item.coverImage;
            });
            that.table_data = res.data.data.list;
            that.page.total = Number(res.data.data.totalItems);
          } else if (res.data.code == 4030) {
          } else if (res.data.code == 2001) {
            that.$message.error("登录失效，请重新登录");
            that.$router.push({ path: "/login" });
          } else {
            that.$message.info(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // methods 结束
  },
};
</script>

<style scoped>
/* 外盒子 */
.management-agent-box {
  height: 100%;
  width: 100%;
  padding: 15px;
  background: #f8fafb;
}
/* 内盒子 */
.content-box {
  width: 100%;
  height: 100%;
}
/* 内容盒子 */
.content_title {
  width: 100%;
  background: #ffffff;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
  border-radius: 5px;
}

/* 内容盒子 */
.content {
  width: 100%;
  height: calc(100% - 90px);
  /* height: 100%; */
  background: #ffffff;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
}
.content_auto {
  height: 100%;
  overflow-y: auto;
}
/* 滚动条样式 */
.content_auto::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.content_auto::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #00cb9f;
}
.content_auto::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(167, 163, 163, 0.2);
  border-radius: 10px;
  background: #ededed;
}

/* 搜索栏 */
.data_screen {
  height: 90px;
  margin-bottom: 15px;
  padding-top: 0px;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}

/* 搜索栏居中 */
.data_screen_line {
  line-height: 32px;
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: flex-start;
}

.data_screen .data_screen_tab {
  margin-left: 20px;
}
/* 标题 */
.title {
  margin-right: 30px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #454647;
  letter-spacing: 0;
}

/* 分页 */
.page {
  /* position:absolute;
  bottom: 50px;
  right: 50px; */
  float: right;
  margin-top: 20px;
}
/* 添加按钮 */
.btn_add {
  position: absolute;
  right: 40px;
}
/* 查询按钮 */
.search_btn{
  margin-left: 20px;
}
.dialog_context {
  width: 450px;
}
.tableImage {
  width: auto;
  height: 80px;
  border: 1px dashed #d9d9d9;
}
.el-form-item__content .avatar-uploader .el-upload--text {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.el-form-item__content .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.el-form-item__content .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;

  border: 1px dashed #d9d9d9;
}
.el-form-item__content .avatar {
  width: auto;
  height: 178px;
  display: block;
  border: 1px dashed #d9d9d9;
}
</style>



// WEBPACK FOOTER //
// src/components/views/tutorial/carousel.vue